import { render, staticRenderFns } from "./MpMaterialNews.vue?vue&type=template&id=2f279f34&"
import script from "./MpMaterialNews.vue?vue&type=script&lang=js&"
export * from "./MpMaterialNews.vue?vue&type=script&lang=js&"
import style0 from "./MpMaterialNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports